import {
  IProjectVersionAttributes,
} from '@SiteModules/ProjectVersion/types'

export default function getShouldAllowToAddLanguages(projectVersionAttributes: IProjectVersionAttributes): boolean {
  const {
    status,
    duration,
    hasMainAssets,
    isDisabled,
    isShortened,
    belongsToTtsProject,
    belongsToManualProject,
  } = projectVersionAttributes

  const durationNotYetDetermined = duration === '00:00' && status === 'downloading'
  const shouldAllowToAddLanguages = !isDisabled && !belongsToManualProject && (hasMainAssets || belongsToTtsProject) && !isShortened && !durationNotYetDetermined

  return shouldAllowToAddLanguages
}
